module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "feed-post"
  }, [_c('section', {
    staticClass: "header"
  }, [(_vm.data.subPosterType === 'developer' && _vm.data.posterDetails.hasBanner) ? _c('div', {
    staticClass: "banner",
    style: (("background-image:url('https://www.develteam.com/userdata/banners/" + (_vm.data.posterDetails.id) + ".png');"))
  }) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game' && _vm.data.subPosterDetails.hasBanner) ? _c('div', {
    staticClass: "banner",
    style: (("background-image:url('https://www.develteam.com/userdata/banners/" + (_vm.data.subPosterDetails.id) + ".png');"))
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "head-group"
  }, [_c('div', {
    staticClass: "headline"
  }, [(_vm.data.subPosterType === 'developer') ? _c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.data.posterDetails,
      "profile-type": _vm.data.subPosterType,
      "size": "large",
      "show-xp-info": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.data.subPosterDetails,
      "profile-type": _vm.data.subPosterType,
      "size": "large",
      "show-xp-info": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [(_vm.data.subPosterType === 'developer') ? _c('span', [_c('i', {
    staticClass: "fas fa-user fa-fw"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/Developer/" + (_vm.data.posterDetails.stringUrl)),
      "data-router-link": "true"
    }
  }, [_vm._v(_vm._s(_vm.data.posterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('span', [_c('i', {
    staticClass: "fas fa-gamepad fa-fw"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/Game/" + (_vm.data.subPosterDetails.stringUrl)),
      "data-router-link": "true"
    }
  }, [_vm._v(_vm._s(_vm.data.subPosterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('span', [_c('i', {
    staticClass: "fas fa-user fa-fw"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/Developer/" + (_vm.data.posterDetails.stringUrl)),
      "data-router-link": "true"
    }
  }, [_vm._v(_vm._s(_vm.data.posterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'status' || _vm.data.type === 'classifieds') ? _c('span', {
    staticClass: "sub-title"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkToPiece
    }
  }, [_vm._v(_vm._s(_vm.data.title))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'media') ? _c('span', {
    staticClass: "sub-title"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkToPiece
    }
  }, [(_vm.data.mediaData.mediaType === 'Image') ? _c('i', {
    staticClass: "fas fa-image fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'External') ? _c('i', {
    staticClass: "fas fa-link fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Archive') ? _c('i', {
    staticClass: "fas fa-archive fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Audio') ? _c('i', {
    staticClass: "fas fa-volume-up fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Flash') ? _c('i', {
    staticClass: "fas fa-rocket fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Text') ? _c('i', {
    staticClass: "fas fa-book fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Video') ? _c('i', {
    staticClass: "fas fa-video fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Youtube') ? _c('i', {
    staticClass: "fab fa-youtube fa-fw portfolio-icon"
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.data.mediaData.title) + "\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post-date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTimeRelative")(_vm.data.postDate)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithJustTime")(_vm.data.postDate)))])]), _vm._v(" "), (_vm.data.isPinned) ? _c('div', {
    staticClass: "pinned-icon"
  }, [_c('i', {
    staticClass: "fa fas fa-thumbtack"
  })]) : _vm._e()])]), _vm._v(" "), (!_vm.isMedia && !_vm.editMode) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.data.content
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isMedia && _vm.editMode && !_vm.deleteMode) ? _c('form', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPostTitle),
      expression: "editPostTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject (optional)"
    },
    domProps: {
      "value": (_vm.editPostTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editPostTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Add a new post"
    },
    model: {
      value: (_vm.editPostContent),
      callback: function($$v) {
        _vm.editPostContent = $$v
      },
      expression: "editPostContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelEditPost($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterDeleteMode($event)
      }
    }
  }, [_vm._v("Delete Post")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveEditPost($event)
      }
    }
  }, [_vm._v("Save")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isMedia && _vm.editMode && _vm.deleteMode) ? _c('form', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Delete this post?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitDeleteMode($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deletePost($event)
      }
    }
  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.isMediaImage) ? _c('media-item-image', {
    attrs: {
      "data": _vm.data.mediaData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaImage && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.data.mediaData.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaVideo) ? _c('media-item-video', {
    attrs: {
      "data": _vm.data.mediaData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaVideo && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.data.mediaData.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaLink) ? _c('media-item-link', {
    attrs: {
      "data": _vm.data.mediaData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaLink && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.data.mediaData.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaAudio) ? _c('media-item-audio', {
    attrs: {
      "data": _vm.data.mediaData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMediaAudio && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.data.mediaData.description
    }
  }) : _vm._e(), _vm._v(" "), _c('footer', [_c('ul', [_c('li', [(!_vm.isMedia) ? _c('voting-widget', {
    attrs: {
      "parent-type": "post",
      "parent-id": _vm.data.id,
      "initial-points": "0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMedia) ? _c('voting-widget', {
    attrs: {
      "parent-type": "media",
      "parent-id": _vm.data.mediaData.id,
      "initial-points": "0"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('li', {
    staticClass: "comments-link-container"
  }, [_c('a', {
    class: ['show-comments', {
      selected: _vm.commentsVisible
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleComments($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.commentCount) + "\n                comments")])]), _vm._v(" "), _c('li', {
    staticClass: "social-sharing"
  }, [_c('i', {
    staticClass: "fab fa-facebook-f",
    on: {
      "click": function($event) {
        _vm.socialShare('facebook')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-twitter",
    on: {
      "click": function($event) {
        _vm.socialShare('twitter')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-linkedin-in",
    on: {
      "click": function($event) {
        _vm.socialShare('linkedin')
      }
    }
  })]), _vm._v(" "), (_vm.canEdit && !_vm.editMode) ? _c('li', {
    staticClass: "edit-button-container",
    on: {
      "click": _vm.enterEditMode
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt edit-button"
  })]) : _vm._e(), _vm._v(" "), (_vm.canEdit && !_vm.editMode) ? _c('li', {
    staticClass: "edit-button-container",
    on: {
      "click": _vm.togglePin
    }
  }, [_c('i', {
    class: ['fas', 'fa-thumbtack', 'edit-button', {
      tilted: _vm.data.isPinned
    }]
  })]) : _vm._e()])]), _vm._v(" "), (_vm.commentsVisible) ? _c('section', {
    staticClass: "comments"
  }, [(Object.keys(_vm.data.comments || {}).length > 0) ? _c('ul', {
    staticClass: "post-comments"
  }, _vm._l((_vm.data.comments), function(comment) {
    return _c('post-comment', {
      attrs: {
        "comment": comment
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('form', {
    staticClass: "new-comment"
  }, [_c('markdown-editor', {
    attrs: {
      "placeholder": "Add a comment"
    },
    model: {
      value: (_vm.newCommentContent),
      callback: function($$v) {
        _vm.newCommentContent = $$v
      },
      expression: "newCommentContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-row"
  }, [(_vm.postAsOptions.length > 1) ? _c('label', [_c('span', [_vm._v("Post as ")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postAs),
      expression: "postAs"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.postAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.postAsOptions), function(postAsOption) {
    return _c('option', {
      domProps: {
        "value": postAsOption.value
      }
    }, [_vm._v(_vm._s(postAsOption.text))])
  }))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitComment($event)
      }
    }
  }, [_vm._v("Submit")])])])], 1) : _c('div', [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/Login"
    }
  }, [_vm._v("Log in")]), _vm._v("\n                to reply\n            ")], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66408bb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FeedPosts/FeedStatusPost.vue
// module id = 882
// module chunks = 2